import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs';

export interface chart {
  type: string;
  mainColor: string;
  sencondaryColor: string;
  lineColor: string;
}

export interface charts {
  chart1: chart;
  chart2: chart;
}

export interface colors {
  principalColors: string[];
  colorGraphic: string[];
  colorGraphic2: string[];
  whiteColor: string;
  fontColor: string;
  backgroundBodyColor: string;
  btoBackgroundColor: string;
  backgroundHeaderPortfolio: string;
}

export interface cssVars {
  colors: colors;
  fontBase: string;
  radiusBoxPortfolio: string;
  radiusBtn: string;
  radiusCardWhite: string;
  radiusModal: string;
  radiusPictures: string;
  charts: charts;
  grayColor03: string;
  grayColor04: string;
  grayColor05: string;
  grayColor08: string;
  negativeColor: string;
  positiveColor: string;
  positiveColor2: string;
  warningColor: string;
  borderCardHover: string;
  borderCardTimeline: string;
  borderCardMain: string;
  altNotification: string;
  altBubble: string;
  altWhite: string;
  borderTabSelectedColor: string;
  borderTabNotselectedColor: string;
  borderTabSelected: string;
  borderTabNotselected: string;
  fontTabSelectedColor: string;
  fontTabNotselectedColor: string;
  backgroundTabSelected: string;
  backgroundTabNotselected: string;
  borderRadiusTab: string;
  shadowTabSelected: string;
  shadowTabNotselected: string;
  borderTabVarSelectedColor: string;
  borderTabVarNotselectedColor: string;
  fontTabVarSelectedColor: string;
  fontTabVarNotselectedColor: string;
  backgroundTabVarSelected: string;
  backgroundTabVarNotselected: string;
  borderRadiusTabVar: string;
  borderTabVarSelected: string;
  shadowTabVarSelected: string;
  borderTabVarNotselected: string;
  shadowTabVarNotselected: string;
  backgroundModal: string;
  backgroundCenteredform: string;
  btoPrimaryColorEnable: string;
  primaryColorHover: string;
  primaryColorActive: string;
  onPrimaryColor: string;
  btoSecondaryColorEnable: string;
  secondaryColorHover: string;
  secondaryColorActive: string;
  onSecondaryColor: string;
  btoDisableColor: string;
  onBtoDisableColor: string;
  altHighlighted: string;
}


@Injectable()
export class AppConfig {
  static settings: any;
  static cssVars: cssVars;
  static configDev: any;

  constructor(private httpBackend: HttpBackend) {}

  load(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const httpclientNoHeaders = new HttpClient(this.httpBackend);
      httpclientNoHeaders
        .get('./assets/AppSetting.json?v=' + Date.now())
        .subscribe(
          (res: cssVars) => {
            AppConfig.configDev = res;
            const httpclientNoHeaders = new HttpClient(this.httpBackend);
            let headers = new HttpHeaders();
            headers = headers.set('Tower30-Domain', AppConfig.configDev.domain);
            httpclientNoHeaders
            .get(AppConfig.configDev.baseApi + '/apirest/portal/businessarea/parameter',{
              headers: headers,
              observe: 'body',
            }).pipe(map((parameters: any) =>{
              const config = [];
              parameters.forEach(parameter => {
                config[parameter.key_name] = (parameter.key_value=="true"||parameter.key_value=="false") ? JSON.parse(parameter.key_value): parameter.key_value;
              });
              return config;
            })
          )
          .subscribe(
            (config: any) => {
              let customThemeFile =
                      localStorage.getItem('MainSettings') == 'true'
                        ? localStorage.getItem('ThemeCss') + '.json'
                        : config.customThemeFile;
                    this.loadtheme(customThemeFile).then(() => {
                      AppConfig.settings = config as any;
                      if(AppConfig.configDev.developerMode) this.loadDeveloperMode();
                      this.loadSetting();                                        
                      resolve();
                    })
              });
          },
          (err) => {
            reject('Could not load the configDev (AppSetting.json) file');
          }
        );
    });
  }

  loadtheme(file): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const httpclientNoHeaders = new HttpClient(this.httpBackend);
      httpclientNoHeaders
        .get('./assets/themes/' + file + '?v=' + Date.now())
        .subscribe(
          (css: cssVars) => {
            AppConfig.cssVars = css as cssVars;
            resolve();
          },
          (err) => {
            reject('Could not load the Themes file');
          }
        );
    });
  }

  private loadSetting() {
    if (localStorage.getItem('MainSettings') != 'true') {
      localStorage.setItem('Language', AppConfig.settings.language);
      localStorage.setItem('ThemeImg', AppConfig.settings.customTheme);
      var customThemeFile = AppConfig.settings.customThemeFile.replace(
        '.json',
        ''
      );
      localStorage.setItem('ThemeCss', customThemeFile);
      localStorage.setItem('OnboardingType', AppConfig.settings.onboardingType);
      localStorage.setItem(
        'AllowOpenNewAccount',
        AppConfig.settings.allowOpenNewAccount.toString()
      );
      localStorage.setItem(
        'SmsVerification',
        AppConfig.settings.SMSVerification
      );
    }
  }
   
  private getAppsetting(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const httpclientNoHeaders = new HttpClient(this.httpBackend);
      httpclientNoHeaders
        .get('./assets/AppSetting.json?v=' + Date.now())
        .subscribe(
          (res: cssVars) => {
            AppConfig.configDev = res;
            resolve();
          },
          (err) => {
            reject('Could not load the configDev (AppSetting.json) file');
          }
        );
    });
  }

  private loadDeveloperMode(){
    Object.entries(AppConfig.configDev).map(entry=>{
      const[key,value] = entry;
      AppConfig.settings[key] = value;
    })
    console.log('DeveloperMode ON');
  }
}
